import type { PlanogramRenderedProduct } from "@augmodo/reusable-components";
import { useActivePlanoProductInfoStore } from "@labeling-tools/ui-components/src/planogram-viewer/use-active-plano-product-info-store";

/**
 * Click bridge from the reusable planogram viewer's product cells into
 * `useActivePlanoProductInfoStore` — the store the legacy viewer's OneLabelBox
 * writes on click, and the one every consumer (coverage-beta's selection
 * bridge, the confirmation task's product details / redux sync) already reads.
 * Shared by every custom `children` renderer so the two viewers stay
 * interchangeable behind their feature gates.
 *
 * `left`/`top` positioned the legacy anchored popover; the reusable cells draw
 * their own chrome, so they're always 0.
 */
export const activatePlanoProduct = (item: PlanogramRenderedProduct) =>
  useActivePlanoProductInfoStore.getState().setActiveLabelBoxInfo({
    left: 0,
    top: 0,
    planogram_product_id: item.product.id,
    product_id: item.product.product_id,
  });

/** The legacy click-again-to-deselect rule: clear when this placement is the active one, else activate it. */
export const togglePlanoProduct = (item: PlanogramRenderedProduct) => {
  const store = useActivePlanoProductInfoStore.getState();
  if (store.productBoxInfo.planogram_product_id === item.product.id) {
    store.reset();
  } else {
    activatePlanoProduct(item);
  }
};
